import store from '@shared/store/index';

const openLegendSubscribe = () => {
  store.dispatch('HeaderSystem/openSubscriptionWidgetFromLegend');
}

export function subscribeWidget(){
  return{
    openLegendSubscribe
  }
}